import React from 'react'
import Img from "gatsby-image"
import styled from 'styled-components'
import { injectIntl } from 'react-intl'

const SlideTestimonial = ({ slides, intl, timer = 4000 }) => {
  const happyPress = useKeyPress('Escape');
  const [openModal, setOpenModal] = React.useState(null)
  const [indexes, setIndexes] = React.useState({
    previousIndex: 0,
    currentIndex: 0,
    nextIndex: 1
  })

  React.useEffect(() => {
    if (openModal) {
      setOpenModal(null)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [happyPress])

  const handleCardTransition = React.useCallback(() => {
    if (indexes.currentIndex >= slides.length - 1) {
      setIndexes({
        previousIndex: slides.length - 1,
        currentIndex: 0,
        nextIndex: 1
      })
    } else {
      setIndexes(prevState => ({
        previousIndex: prevState.currentIndex,
        currentIndex: prevState.currentIndex + 1,
        nextIndex:
          prevState.currentIndex + 2 === slides.length
            ? 0
            : prevState.currentIndex + 2
      }))
    }
  }, [indexes.currentIndex, slides]);

  React.useEffect(() => {
    const transitionInterval = setInterval(() => handleCardTransition(), timer)
    return () => clearInterval(transitionInterval)
  }, [handleCardTransition, indexes, timer])

  const getClassSlide = index => {
    let state = ''

    if (indexes.currentIndex === index) {
      state = 'card-testimonial--current'
    }

    return `card-testimonial ${state} ${slides.length === 1 && 'card-testimonial--uniq'}`
  }

  return (
    <Wrapper>
      {slides.map((slide, key) => (
        <div key={key}>
          {slide.full && (
            <ModalWindow className={openModal === key ? 'active' : undefined}>
              <button aria-label="Close" className="card-background" onClick={() => setOpenModal(null)} />
              <div className="card-modal">
                <button onClick={() => setOpenModal(null)} className="modal-close">{intl.messages.card_testimonial.close}</button>
                <h4>{intl.messages.card_testimonial.full_testimonial} {slide.name}</h4>
                <div className="content-modal">{slide.full}</div>
              </div>
            </ModalWindow>
          )}
        </div>
      ))}
      {slides.map((slide, key) => (
        <div 
          key={key} 
          className={`${getClassSlide(key)}`}
          style={{ backgroundColor: slide.backgroundColor, color: slide.colorText }}>
          {slide.backgroundImage && <div className="card-testimonial__image" style={{ backgroundImage: `url(${slide.backgroundImage.src})` }} />}
          {slide.logo && <Img fixed={slide.logo} alt={slide.name} />}
          <div className="card-testimonial__text" style={{ color: slide.colorText }}>{slide.resume}</div>
          {slide.full && <button style={{ color: slide.colorText, borderColor: slide.colorText }} onClick={() => setOpenModal(key)}>{intl.messages.card_testimonial.read_full_testimonial}</button>}
          {slide.person && <div className="card-testimonial__person">
            <div className="card-testimonial__person-name" style={{ color: slide.colorText }}>{slide.person.name}</div>
            <div className="card-testimonial__person-position" style={{ color: slide.colorText }}>{slide.person.position}</div>
          </div>}
        </div>
      ))}
      {slides.length > 1 && (
        <div className="indicators">
          <button 
            className="indicators__direction"
            onClick={() => {
              setIndexes(v => {
                return {
                  previousIndex: v.currentIndex - 1 < 0 ? slides.length - 2 : v.currentIndex - 2,
                  currentIndex: v.currentIndex - 1 < 0 ? slides.length - 1 : v.currentIndex - 1,
                  nextIndex: v.currentIndex
                }
              })
            }}
            >
            <i className="arrow left" />
          </button>
          {slides.map((slide, key) => (
            // eslint-disable-next-line
            <button 
              key={key} 
              className={`steps ${indexes.currentIndex === key && 'active'}`}
              onClick={() => { setIndexes(v => { return { ...v, currentIndex: key } }) }}
            />
          ))}
          <button 
            className="indicators__direction"
            onClick={() => {
              setIndexes(v => {
                return {
                  previousIndex: v.currentIndex,
                  currentIndex: v.currentIndex + 1 === slides.length ? 0 : v.currentIndex + 1,
                  nextIndex: v.currentIndex + 2 === slides.length ? 0 : v.currentIndex + 2
                }
              })
            }}>
            <i className="arrow right" />
          </button>
        </div>
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  overflow: hidden;
  width: calc(100%);
  border-radius: 6px;
  position: relative;
  margin-right: 10px;
  margin-bottom: 30px;
  -webkit-box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.14);
  -moz-box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.14);
  box-shadow: 0px 2px 5px 0px rgba(0,0,0,0.14);

  @media screen and (max-width: 1000px) {
    margin-right: 0;
  }

  .arrow {
    border: solid #888;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 3px;

    &.right {
      transform: rotate(-45deg);
      -webkit-transform: rotate(-45deg);
    }

    &.left {
      transform: rotate(135deg);
      -webkit-transform: rotate(135deg);
    }
  }

  .indicators {
    position: absolute;
    z-index: 9;
    bottom: 20px;
    transform: translateX(-50%);
    left: 50%;
    display: flex;

    &__direction {
      color: #888;
      width: 40px;
      height: 40px;
      border: 0;
      background: transparent;
      outline: none;
      position: relative;
      cursor: pointer;

      &:hover {
        transform: scale(1.4);
      }
    }

    button.steps {
      color: #fff;
      width: 40px;
      height: 40px;
      border: 0;
      background: transparent;
      outline: none;
      position: relative;
      cursor: pointer;

      &::after {
        content: '';
        width: 10px;
        height: 10px;
        background: #888;
        position: absolute;
        left: 50%;
        top: 50%;
        margin-left: -5px;
        margin-top: -5px;
        border-radius: 10px;
        opacity: .5;
      }

      &:hover {
        &::after {
          opacity: 1 !important;
          background-color: var(--color-primary);
        }
      }

      &.active {
        &::after {
          opacity: 1;
        }
      }
    }
  }

  .card-testimonial {
    width: calc(100%);
    padding: 40px 40px 80px 40px;
    display: none;

    &--current {
      display: block;
    }

    &--uniq {
      padding-bottom: 40px;
    }

    
    &--james { background-color: #984ded; }
    &--rana { background-color: #1e6fad; }
    &--skillcore, &--logicaldelivery { background-color: #0e0e0e; }
    &--quadritech { background-color: #0089bd; }

    &__image {
      height: 205px;
      margin-left: -40px;
      margin-top: -40px;
      margin-right: -40px;
      background-size: cover;
      background-position: center;
      margin-bottom: 40px;
    }

    &__text {
      color: #fff;
      font-weight: 300;
      font-size: 20px;
      line-height: 1.3;
      margin-top: 20px;
      font-style: italic;
    }

    button {
      background: transparent;
      border: 1px solid #fff;
      color: #fff;
      height: 35px;
      padding: 0 15px;
      border-radius: 6px;
      margin-top: 20px;
      cursor: pointer;
    }

    &__person {
      margin-top: 20px;

      &-name {
        color: #fff;
        font-size: 18px;
        font-weight: bold;
      }

      &-position {
        color: #fff;
        font-size: 14px;
      }
    }
  }
`

const ModalWindow = styled.div`
  position: fixed;
  background-color: rgba(0, 0, 0, 0.75);
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999999;
  visibility: hidden;
  opacity: 0;
  /* pointer-events: none; */
  transition: all 0.3s;

  &.active {
    visibility: visible;
    opacity: 1;
    pointer-events: auto;
  }

  .card-background {
    width: 100%;
    position: absolute;
    height: 100%;
    top: 0;
    left: 0;
    z-index: -1;
    background: transparent;
    border: 0;
  }

  div.card-modal {
    width: 90%;
    max-width: 650px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 0;
    background: #ffffff;
    border-radius: 6px;
  }

  .modal-close {
    color: #b34242;
    position: absolute;
    right: 0;
    text-align: center;
    background: transparent;
    border: 1px solid #fdc6c6;
    top: -42px;
    -webkit-text-decoration: none;
    padding: 7px 15px;
    -webkit-text-decoration: none;
    text-decoration: none;
    cursor: pointer;
    border-radius: 4px;
    background: #ffebeb;
  }

  .content-modal {
    max-height: calc(100vh - 230px);
    overflow-y: scroll;
    padding: 20px;
    padding-top: 0;

    h5 {
      font-size: 18px;
      font-weight: bold;
      color: #000;
      margin-bottom: 10px;
    }

    p {
      margin-bottom: 15px;
    }
  }
  
  header {
    font-weight: bold;
  }

  h4 {
    font-size: 24px !important;
    color: #000;
    margin: 20px 20px 15px 20px;
  }
`

export default injectIntl(SlideTestimonial)

function useKeyPress(targetKey) {
  // State for keeping track of whether key is pressed
  const [keyPressed, setKeyPressed] = React.useState(false);

  // If pressed key is our target key then set to true
  function downHandler({ key }) {
    if (key === targetKey) {
      setKeyPressed(true);
    }
  }

  // If released key is our target key then set to false
  const upHandler = ({ key }) => {
    if (key === targetKey) {
      setKeyPressed(false);
    }
  };

  // Add event listeners
  React.useEffect(() => {
    window.addEventListener('keydown', downHandler);
    window.addEventListener('keyup', upHandler);
    // Remove event listeners on cleanup
    return () => {
      window.removeEventListener('keydown', downHandler);
      window.removeEventListener('keyup', upHandler);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return keyPressed;
}